import { useTranslate } from "@similarweb/i18n-provider";
import { EmptyState } from "@similarweb/ui-components";

import { SerpOverlayErrorState } from "./SerpOverlayErrorState";
import { SerpOverlayIframePanels } from "./SerpOverlayIframePanels";
import { SerpOverlayContentWrapper } from "./styles";
import type { SerpSnapshotDataRecords } from "./types";

type Props = {
    records: SerpSnapshotDataRecords;
    activePageIndex: number;
    hasError: boolean;
    iframeErrorsByPageIndex: Record<number, boolean>;
    onIframeError: (pageIndex: number) => void;
};

export const SerpOverlayContent = ({
    records,
    activePageIndex,
    hasError,
    iframeErrorsByPageIndex,
    onIframeError,
}: Props) => {
    const { translate } = useTranslate();

    if (hasError) {
        return (
            <SerpOverlayContentWrapper
                alignItems="center"
                justifyContent="center"
                data-automation="serp-overlay-error"
            >
                <SerpOverlayErrorState />
            </SerpOverlayContentWrapper>
        );
    }

    if (records && records.length === 0) {
        return (
            <SerpOverlayContentWrapper
                alignItems="center"
                justifyContent="center"
                data-automation="serp-overlay-empty"
            >
                <EmptyState
                    title={translate("rankTracker.serpOverlay.empty.title")}
                    subtitle={translate("rankTracker.serpOverlay.empty.subtitle")}
                />
            </SerpOverlayContentWrapper>
        );
    }

    return (
        <SerpOverlayContentWrapper data-automation="serp-overlay-iframe-panels">
            <SerpOverlayIframePanels
                records={records}
                activePageIndex={activePageIndex}
                iframeErrorsByPageIndex={iframeErrorsByPageIndex}
                onIframeError={onIframeError}
            />
        </SerpOverlayContentWrapper>
    );
};
